module.exports = __webpack_public_path__ + "static/img/home001.22e5a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/home001.png
// module id = TW93
// module chunks = 0